<template>
    <div>
      <Header />
      <main class="app-content">
        <div class="app-title">
          <div>
            <h1><i class="fa fa-dashboard"></i>MAKİNE GİDER FİLTRELEME</h1>
          </div>
          <ul class="app-breadcrumb breadcrumb">
            <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
            <li class="breadcrumb-item">
              <a href="#">MAKİNE GİDER FİLTRELEME</a>
            </li>
          </ul>
        </div>
        <div class="row form-margin">
          <div class="col-md-12 tex-center d-flex align-items-center flex-column">
            <div class="tile">
              <h3 class="tile-title">MAKİNE GİDER FİLTRELEME</h3>
  
              <div class="tile-body">
                <form>
                  <div id="app">
                    <label class="control-label"
                      >MAKİNE SEÇİNİZ</label
                    >
                    <select class="form-control" @change="getBySaha($event)">
                      <option value="" selected disabled>MAKİNE SEÇİNİZ</option>
                      <option
                        v-for="makina in makineler"
                        :value="makina.id"
                        :key="makina.id"
                        >{{ makina.makina_code +" " + makina.makina_name}}</option
                      >
                    </select>
                  </div>
                </form>
                <div class="form-group">
                    <label class="control-label">Filtreleme Başlangıç Tarihi</label>
                    <br />
                    <input v-model="baslangicdate" type="date" />
                  </div>
                  <hr>
                  <div class="form-group">
                    <label class="control-label">Filtreleme Bitiş Tarihi</label>
                    <br />
                    <input v-model="bitisdate" type="date" />
                  </div>
              </div>
            </div>
            <button @click="sendData()" class="btn btn-primary" type="button">
                <i class="fa fa-fw fa-lg fa-check-circle"></i>FİLTRELE
              </button>
          </div>
        </div>
      </main>
  
      <Sidebar />
    </div>
  </template>
  
  <script>
  import Header from "./default/Header";
  import Sidebar from "./default/Sidebar";
  import axios from "axios";
  import store from "../store";
  import PersonelEkle from "./PersonelEkle.vue";
  export default {
    data() {
      return {
        sahaname: "",
        personeller: [],
        makineler: [],
        cap_delgi: "",
        makineId: "",
        baslangicdate: "",
        bitisdate: "",
        toplam_delgi: "",
        personelId: "",
      };
    },
    mounted() {
      window.scrollTo(0, 0);
    //   var admin_token = localStorage.getItem("admin_token");
    //   if (!admin_token) {
    //     this.$router.push("/");
    //   }
      var url = store.state.base_url + "AslanSahalar/getAllYeoMakineler.php?key=123";
      axios
        .post(url)
        .then((response) => {
          this.makineler = response.data;
          console.log(this.makineler);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    methods: {
      getBySaha(event) {
        this.makineId = event.target.value;   
      
      },
      reload: function() {
        location.reload();
      },
      changemakina(event) {
      this.makineId = event.target.value;
    },
      sendData: function() {
        console.log(this.oprone);
        if (this.makineId == "") {
          this.$swal({
            text: "MAKİNE SEÇİNİZ!",
            icon: "error",
            closeOnClickOutside: false,
          });
        } else if (this.baslangicdate == "") {
          this.$swal({
            text: "BALANGIÇ TARİHİ SEÇİNİZ!",
            icon: "error",
            closeOnClickOutside: false,
          });
        }  else if (this.bitisdate == "") {
          this.$swal({
            text: "BİTİŞ TARİHİ SEÇİNİZ!",
            icon: "error",
            closeOnClickOutside: false,
          });
        } else {
            window.open(`https://www.apidosya.aslanyazilimm.com/DosyaApi/yeoMakineGider.php?key=123&keyword=${this.makineId}&mlml=${this.baslangicdate}&mlms=${this.bitisdate}`, "_blank");
 
        }
      },
    },
  
    components: {
      Header,
      Sidebar,
    },
  };
  </script>
  


// WEBPACK FOOTER //
// src/components/YeoMakineGider.vue